import Pagination from "react-js-pagination";
import arrows from "../../../../../Assets/Images/arrows.svg";
import profilePic from "../../../../../Assets/Images/avatar.svg";
import { isValidString, serialNo } from "../../../../../helper";
import {
  BsCaretDownFill,
  BsCaretDown,
  BsCaretUpFill,
  BsCaretUp,
} from "react-icons/bs";

const Table = ({
  data,
  activePage,
  handlePageChange,
  order,
  toggleOrder,
  requestType,
  toggleRequestType,
}) => {
  return (
    <div
      div
      className="activity-detail details-column shadow card mx-sm-0 mx-md-2 my-4 border-0"
    >
      <p className="hdng-para">Details of activities</p>
      <div className="row">
        <div className="col-12 mx-auto">
          <div className="detail-table">
            <p className="table-hdng">Most active students list</p>
            <div className="table-responsive">
              <div className="table mb-0">
                <table class="table border mb-0">
                  <thead className="heading">
                    <tr className="hdng-row">
                      <th>S.no</th>
                      <th></th>
                      <th>Name</th>
                      <th>Class</th>
                      <th>
                        Submissions
                        <span className="sort-icons">
                          {requestType === "performance" ? (
                            <>
                              <BsCaretUp
                                onClick={() => toggleRequestType("asc")}
                              />
                              <BsCaretDown
                                onClick={() => toggleRequestType("desc")}
                              />
                            </>
                          ) : order === "desc" ? (
                            <>
                              <BsCaretUp
                                onClick={() => toggleRequestType("asc")}
                              />
                              <BsCaretDownFill />
                            </>
                          ) : (
                            <>
                              <BsCaretUpFill />
                              <BsCaretDown
                                onClick={() => toggleRequestType("desc")}
                              />
                            </>
                          )}
                        </span>
                      </th>
                      <th>
                        %
                        <span className="sort-icons">
                          {requestType === "submission" ? (
                            <>
                              <BsCaretUp onClick={() => toggleOrder("asc")} />
                              <BsCaretDown
                                onClick={() => toggleOrder("desc")}
                              />
                            </>
                          ) : order === "desc" ? (
                            <>
                              <BsCaretUp onClick={() => toggleOrder("asc")} />
                              <BsCaretDownFill />
                            </>
                          ) : (
                            <>
                              <BsCaretUpFill />
                              <BsCaretDown
                                onClick={() => toggleOrder("desc")}
                              />
                            </>
                          )}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.data?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{serialNo(index, activePage)}.</td>
                          <td>
                            <img
                              className="rounded-circle"
                              src={isValidString(item?.profileUrl) ? item?.profileUrl : profilePic}
                              alt="profilePic"
                              width={28}
                              height={28}
                            />
                          </td>
                          <td>{item?.name}</td>
                          <td>{item?.kidClass}</td>
                          <td>{item?.submissions}</td>
                          <td>{Math.ceil(item?.score)}%</td>
                        </tr>
                      );
                    })}
                    {(data?.data?.length < 1 || !data?.data) && (
                      <tr>
                        <td colSpan={5}>
                          <h5 className="mb-0 text-center d-block">
                            No data found
                          </h5>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {data?.pagination_info && (
              <div className="pagination-bar w-100 d-flex justify-content-between border-top-0">
                <p className="counting mb-0">
                  {activePage} out of {data?.pagination_info?.total_pages}
                </p>
                <nav aria-label="Page navigation example">
                  <Pagination
                    activePage={activePage}
                    itemsCountPerPage={data?.pagination_info?.page_size}
                    totalItemsCount={data?.pagination_info?.total_elements}
                    pageRangeDisplayed={5}
                    innerClass="pagination mb-0 p-0"
                    itemClass="page-item"
                    linkClass="page-link"
                    onChange={handlePageChange}
                  />
                </nav>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Table;
